import React from 'react';
import HeroSection from '../components/HeroSection';
import { UpcomingPujas, HowItWorks } from '../components/UpcomingAndHow';
import { DevoteeCorner, FAQs, Subscribe } from '../components/DevoteeAndFAQ';
import StatsSection from '../components/StatsSection';
import BookCTA from '../components/BookCTA';
import useScrollReveal from '../hooks/useScrollReveal';

export default function Home() {
  useScrollReveal();
  return (
    <div>
      <HeroSection />
      <div className="reveal"><UpcomingPujas /></div>
      <div className="reveal reveal-delay-1"><HowItWorks /></div>
      <div className="reveal reveal-delay-2"><StatsSection /></div>
      <div className="reveal"><DevoteeCorner /></div>
      <div className="reveal reveal-delay-1"><FAQs /></div>
      <div className="reveal reveal-delay-2"><BookCTA /></div>
      <div className="reveal"><Subscribe /></div>
    </div>
  );
}
